import { render, staticRenderFns } from "./specificationPackageModal.vue?vue&type=template&id=6953a5e3&scoped=true"
import script from "./specificationPackageModal.vue?vue&type=script&lang=js"
export * from "./specificationPackageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6953a5e3",
  null
  
)

export default component.exports